function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import db from "./db";
/**
 * All the authz-related lookups that need to be relatively fast
 */ export const applicationIdFromPaywallId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ paywallId }) {
        let { applicationId } = (yield db.paywall.findUnique({
            where: {
                id: paywallId
            },
            select: {
                applicationId: true
            }
        })) || {};
        return applicationId;
    });
    return function applicationIdFromPaywallId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const organizationIdFromProjectId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ projectId }) {
        let { organizationId } = (yield db.project.findUnique({
            where: {
                id: projectId
            },
            select: {
                organizationId: true
            }
        })) || {};
        return organizationId;
    });
    return function organizationIdFromProjectId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const applicationIdFromSurveyId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ surveyId }) {
        let { applicationId } = (yield db.survey.findUnique({
            where: {
                id: surveyId
            },
            select: {
                applicationId: true
            }
        })) || {};
        return applicationId;
    });
    return function applicationIdFromSurveyId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const applicationIdFromWebPaywallId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ webPaywallId }) {
        let { applicationId } = (yield db.webPaywall.findUnique({
            where: {
                id: webPaywallId
            },
            select: {
                applicationId: true
            }
        })) || {};
        return applicationId;
    });
    return function applicationIdFromWebPaywallId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const applicationIdFromWebPaywallTriggerId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ webPaywallTriggerId }) {
        let { applicationId } = (yield db.webPaywallTrigger.findUnique({
            where: {
                id: webPaywallTriggerId
            },
            select: {
                applicationId: true
            }
        })) || {};
        return applicationId;
    });
    return function applicationIdFromWebPaywallTriggerId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const applicationIdFromWebProductId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ webProductId }) {
        let { applicationId } = (yield db.webProduct.findUnique({
            where: {
                id: webProductId
            },
            select: {
                applicationId: true
            }
        })) || {};
        return applicationId;
    });
    return function applicationIdFromWebProductId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const notificationTimelineIdFromNotificationNodeId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ notificationNodeId }) {
        let { notificationTimelineId } = (yield db.notificationNode.findUnique({
            where: {
                id: notificationNodeId
            },
            select: {
                notificationTimelineId: true
            }
        })) || {};
        return notificationTimelineId;
    });
    return function notificationTimelineIdFromNotificationNodeId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const notificationNodeIdFromNotificationPlanId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ notificationPlanId }) {
        let { notificationNodeId } = (yield db.notificationPlan.findUnique({
            where: {
                id: notificationPlanId
            },
            select: {
                notificationNodeId: true
            }
        })) || {};
        return notificationNodeId;
    });
    return function notificationNodeIdFromNotificationPlanId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const applicationIdFromapplicationWebhookDestinationId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ applicationWebhookDestinationId }) {
        let { applicationId } = (yield db.applicationWebhookDestination.findUnique({
            where: {
                id: applicationWebhookDestinationId
            },
            select: {
                applicationId: true
            }
        })) || {};
        return applicationId;
    });
    return function applicationIdFromapplicationWebhookDestinationId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const applicationIdFromNotificationTimelineId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ notificationTimelineId }) {
        let { applicationId } = (yield db.notificationTimeline.findUnique({
            where: {
                id: notificationTimelineId
            },
            select: {
                applicationId: true
            }
        })) || {};
        return applicationId;
    });
    return function applicationIdFromNotificationTimelineId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const applicationIdFromNotificationTimelineV2Id = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ notificationTimelineV2Id }) {
        let { applicationId } = (yield db.notificationTimelineV2.findUnique({
            where: {
                id: notificationTimelineV2Id
            },
            select: {
                applicationId: true
            }
        })) || {};
        return applicationId;
    });
    return function applicationIdFromNotificationTimelineV2Id(_) {
        return _ref.apply(this, arguments);
    };
}();
export const notificationTimelineV2IdFromNotificationNodeV2Id = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ notificationNodeV2Id }) {
        let { notificationTimelineV2Id } = (yield db.notificationNodeV2.findUnique({
            where: {
                id: notificationNodeV2Id
            },
            select: {
                notificationTimelineV2Id: true
            }
        })) || {};
        return notificationTimelineV2Id;
    });
    return function notificationTimelineV2IdFromNotificationNodeV2Id(_) {
        return _ref.apply(this, arguments);
    };
}();
export const applicationIdFromProductId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ productId }) {
        let { applicationId } = (yield db.product.findUnique({
            where: {
                id: productId
            },
            select: {
                applicationId: true
            }
        })) || {};
        return applicationId;
    });
    return function applicationIdFromProductId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const applicationIdFromExperimentId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ experimentId }) {
        let { applicationId } = (yield db.experiment.findUnique({
            where: {
                id: experimentId
            },
            select: {
                applicationId: true
            }
        })) || {};
        return applicationId;
    });
    return function applicationIdFromExperimentId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const applicationIdFromExperimentGroupId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ experimentGroupId }) {
        let { applicationId } = (yield db.triggerExperimentGroup.findUnique({
            where: {
                id: experimentGroupId
            },
            select: {
                applicationId: true
            }
        })) || {};
        return applicationId;
    });
    return function applicationIdFromExperimentGroupId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const applicationIdIdFromPaywallTriggerExperimentId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ paywallTriggerExperimentId }) {
        var _triggerExperiment_triggerExperimentGroup;
        const triggerExperiment = yield db.triggerExperiment.findUnique({
            where: {
                id: paywallTriggerExperimentId
            },
            select: {
                triggerExperimentGroup: {
                    select: {
                        applicationId: true
                    }
                }
            }
        });
        return triggerExperiment === null || triggerExperiment === void 0 ? void 0 : (_triggerExperiment_triggerExperimentGroup = triggerExperiment.triggerExperimentGroup) === null || _triggerExperiment_triggerExperimentGroup === void 0 ? void 0 : _triggerExperiment_triggerExperimentGroup.applicationId;
    });
    return function applicationIdIdFromPaywallTriggerExperimentId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const applicationIdFromTriggerExperimentGroupId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ triggerExperimentGroupId }) {
        let { applicationId } = (yield db.triggerExperimentGroup.findUnique({
            where: {
                id: triggerExperimentGroupId
            },
            select: {
                applicationId: true
            }
        })) || {};
        return applicationId;
    });
    return function applicationIdFromTriggerExperimentGroupId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const experimentIdFromVariantId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ variantId }) {
        let { experimentId } = (yield db.variant.findUnique({
            where: {
                id: variantId
            },
            select: {
                experimentId: true
            }
        })) || {};
        return experimentId;
    });
    return function experimentIdFromVariantId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const applicationIdFromVariantId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ variantId }) {
        const experimentId = yield experimentIdFromVariantId({
            variantId
        });
        return yield applicationIdFromExperimentId({
            experimentId: experimentId
        });
    });
    return function applicationIdFromVariantId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const applicationIdFromPaywallTriggerId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ paywallTriggerId }) {
        let { applicationId } = (yield db.paywallTrigger.findUnique({
            where: {
                id: paywallTriggerId
            },
            select: {
                applicationId: true
            }
        })) || {};
        return applicationId;
    });
    return function applicationIdFromPaywallTriggerId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const organizationIdFromApplicationId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ applicationId }) {
        let { organizationId } = (yield db.application.findUnique({
            where: {
                id: applicationId
            },
            select: {
                organizationId: true
            }
        })) || {};
        return organizationId;
    });
    return function organizationIdFromApplicationId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const organizationIdFromMembershipId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ membershipId }) {
        let { organizationId } = (yield db.membership.findUnique({
            where: {
                id: membershipId
            },
            select: {
                organizationId: true
            }
        })) || {};
        return organizationId;
    });
    return function organizationIdFromMembershipId(_) {
        return _ref.apply(this, arguments);
    };
}();
export const userHasOrganizationMembership = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ userId, organizationId }) {
        if (userId === null) {
            return undefined;
        }
        const membership = yield db.membership.findFirst({
            where: {
                userId,
                organizationId
            },
            select: {
                role: true
            },
            take: 1
        });
        return membership === null || membership === void 0 ? void 0 : membership.role;
    });
    return function userHasOrganizationMembership(_) {
        return _ref.apply(this, arguments);
    };
}();
export const paywallTemplateTypeFromPaywallId = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ paywallId }) {
        let { templateType } = (yield db.paywall.findUnique({
            where: {
                id: paywallId
            },
            select: {
                templateType: true
            }
        })) || {};
        return templateType;
    });
    return function paywallTemplateTypeFromPaywallId(_) {
        return _ref.apply(this, arguments);
    };
}();
